/** What a Markdown-only file picker offers. */
export const MARKDOWN_FILE_ACCEPT = ".md,.markdown,text/markdown";

export const isMarkdownFile = (file: File): boolean =>
  file.type === "text/markdown" ||
  file.type === "text/x-markdown" ||
  /\.(md|markdown|mdown|mkd)$/i.test(file.name);

/** A file's name without its extension, e.g. a document title from `voice.md`. */
export const fileNameWithoutExtension = (fileName: string): string =>
  fileName.replace(/\.[^.]+$/, "");
